<template>
  <div class="reason-action-box">
    <el-dialog top="20px" :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" align="center" :close-on-click-modal="false" class="el-dialogs">
      <el-form label-width="0px" class="form-inline" align="left">
        <el-form-item>
          <el-button type="danger" :disabled="isEdit" icon="el-icon-plus" @click="handlerAdd">新增原因</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" :loading="loading" border>
        <el-table-column prop="content" label="驳回原因" width="370" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.content">{{ scope.row.content }}</span>
            <div v-else class="inline-item">
              <el-form :model="params" :inline="true" ref="form" label-width="0px" class="form-inline" align="center" size="mini">
                <el-form-item prop="content" style="width: 180px; margin-bottom: 0;">
                  <el-input v-model="params.content" type="textarea" :placeholder="scope.row._placeholder" size="small" />
                </el-form-item>
                <el-form-item style="width: 60px">
                  <el-button type="success" :loading="flag" size="small" @click="submitReason(scope.row)">确认</el-button>
                </el-form-item>
                <el-form-item style="width: 60px">
                  <el-button type="primary" size="small" @click="handlerCancel()">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="success" size="small" @click="handlerEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="delReason(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total>pageSize" class="table-pagination">
        <el-pagination :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'

export default {
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      // 弹窗标题
      title: '原因列表',
      // 原因类型
      type: '',
      // 提交按钮状态
      flag: false,
      // 表格加载状态
      loading: false,
      isEdit: false,
      // 新增帖子请求参数
      params: {
        content: ''
      },
      tableData: [],
      pageSize: 5,
      pageNum: 1,
      total: 0
    }
  },
  created() {
  },
  methods: {
    // 获取驳回原因列表
    getReasonList() {
      this.loading = true
      const params = Object.assign({}, {
        type: this.type,
        page: this.pageNum,
        pageSize: this.pageSize
        // content: this.params.content
      })
      API.getReasonList(params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.total = res.data.total
          this.tableData = res.data.list || []
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.loading = false
      })
    },
    handleSizeChange() {
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getReasonList()
    },
    handlerAdd() {
      this.tableData.unshift({ id: 'add', content: '', _placeholder: '请输入新增原因' })
      this.isEdit = true
    },
    handlerEdit(row) {
      if (this.isEdit) {
        this.$message.error('请先完成新增或其他列的修改！')
        return false
      }
      row._placeholder = row.content
      row.content = ''
      this.isEdit = true
    },
    handlerCancel() {
      this.isEdit = false
      this.params.content = ''
      this.getReasonList()
    },
    submitReason(row) {
      this.isEdit = false
      if (row.id === 'add') {
        this.addReason()
      } else {
        this.editReason(row)
      }
      this.params.content = ""
    },
    editReason(row) {
      this.flag = true
      const params = Object.assign({}, {
        id: row.id,
        content: this.params.content
      })
      API.editReasonList(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          });
        } else {
          this.$message.error('编辑失败！')
        }
        this.flag = false
        this.$message.error('编辑失败！')
      }).catch(() => {
        this.getReasonList()
        this.flag = false
        this.$message.error('编辑失败！')
      })
    },
    addReason() {
      this.flag = true
      const params = {
        type: this.type,
        content: this.params.content,
      }
      API.addReasonList(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: '添加成功！',
              type: 'success'
            })
            this.params.content = ''
            this.pageNum = 1
          } else {
            this.$message.error('新增失败！');
          }
          this.flag = false
          this.getReasonList()
        })
        .catch(() => {
          this.flag = false
          this.getReasonList()
          this.$message.error('添加失败！')
        })
    },
    delReason(row) {
      this.$confirm('您确定要删除当前原因吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const params = Object.assign({}, {
          ids: [row.id],
        })
        API.delReasonList(params).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          this.getReasonList()
          } else {
            this.$message.error('删除失败！');
          }
        })
        .catch(() => {
          this.flag = false
          this.getReasonList()
          this.$message.error('删除失败！')
        })
      })
    },
    // 数据提交验证
    // submitForm() {
    //   this.$refs.form.validate(valid => {
    //     if (valid) {
    //       this.flag = true
    //       this.rejectPosts()
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.params = {
        content: ''
      }
      this.isEdit = false
      this.tableData = []
      // this.$refs.form.resetFields()
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type) {
      this.dialogVisible = true
      this.type = type
      this.getReasonList()
    }
  }
}
</script>

<style lang="scss" scoped>
.reason-action-box {
  .inline-item {
    display: flex;
    align-items: center;
  }
}
</style>
